module.exports = __webpack_public_path__ + "static/media/PowerPay.1c923b03.png";